import { GetNameWithTranslation } from './Functions/GetNameWithTranslation';
import { ActuatorStateI } from './redux/types/app';

export const actuators: ActuatorStateI[] = [
    
    /*
        WIRELESS
    */
    // Lightning Switching
    {
        tech: 'wireless',
        type: 'RFSAI-61B-SL',
        applianceType: 'lighting',
        name: GetNameWithTranslation('1x 8A', 'channel', undefined, 'box'),
        refImg: 'RFSAI-61B-SL.png',
        icon: 'switching_actuator_box',
        dinrail: false,
        numberOfChannels: 1,
        usage: 'switching',
        price: 65.34  
    },
    {
        tech: 'wireless',
        type: 'RFSAI-62B-SL',
        applianceType: 'lighting',
        name: GetNameWithTranslation('2x 8A', 'channels', undefined, 'box'),
        refImg: 'RFSAI-62B-SL.png',
        icon: 'switching_actuator_box',
        dinrail: false,
        numberOfChannels: 2,
        usage: 'switching',
        price: 68.48
    },
    {
        tech: 'wireless',
        type: 'RFSA-61MI',
        applianceType: 'lighting',
        name: GetNameWithTranslation('1x 16A', 'channel', undefined, 'din'),
        refImg: 'RFSA-61MI.png',
        icon: 'actuator_din_1',
        dinrail: true,
        numberOfChannels: 1,
        usage: 'switching',
        modules: 1,
        price: 58.37
    },
    {
        tech: 'wireless',
        type: 'RFSA-66MI',
        applianceType: 'lighting',
        name: GetNameWithTranslation('6x 8A', 'channels', undefined, 'din'),
        refImg: 'RFSA-66M.png',
        icon: 'actuator_din_3',
        dinrail: true,
        numberOfChannels: 6,
        usage: 'switching',
        modules: 3,
        price: 125.49
    },
    // Lightning Dimming
    {
        tech: 'wireless',
        type: 'RFDEL-71B-SL',
        applianceType: 'lighting',
        name: GetNameWithTranslation('', 'universal_300w_dimmer', undefined, 'box'),
        refImg: 'RFDEL-71B-SL.png',
        icon: 'phase_actuator_box',
        dinrail: false,
        numberOfChannels: 1,
        usage: 'dimming',
        price: 75.12
    },
    {
        tech: 'wireless',
        type: 'RFDALI-04B-SL',
        applianceType: 'lighting',
        name: `${GetNameWithTranslation('', 'dali_dimmer')} ${GetNameWithTranslation('4', 'channels', undefined, 'box')}`,
        refImg: 'RFDALI-04B-SL.png',
        icon: 'dali_actuator_box_4x',
        dinrail: false,
        numberOfChannels: 4,
        usage: 'dali-dimming',
        price: 94.80
    },
    {
        tech: 'wireless',
        type: 'RFDALI-32B-SL',
        applianceType: 'lighting',
        name: `${GetNameWithTranslation('', 'dali_dimmer')} ${GetNameWithTranslation('32', 'channels', undefined, 'box')}`,
        refImg: 'RFDALI-32B-SL.png',
        icon: 'dali_actuator_box_32x',
        dinrail: false,
        numberOfChannels: 32,
        usage: 'dali-dimming',
        price: 150
    },
    {
        tech: 'wireless',
        type: 'RFDAC-71B-SL',
        applianceType: 'lighting',
        name: `${GetNameWithTranslation('', 'analog_dimmer', undefined, 'box')}, 0-10V`,
        refImg: 'RFDAC-71B-SL.png',
        icon: 'phase_actuator_box',
        dinrail: false,
        numberOfChannels: 1,
        usage: 'dimming',
        price: 76.66
    },
    {
        tech: 'wireless',
        type: 'RFDEL-71M',
        applianceType: 'lighting',
        name: GetNameWithTranslation('', 'universal_600w_dimmer', undefined, 'box'),
        refImg: 'RFDEL-71M.png',
        icon: 'phase_actuator_din_3',
        dinrail: true,
        numberOfChannels: 1,
        usage: 'dimming',
        modules: 3,
        price: 139.56
    },
    {
        tech: 'wireless',
        type: 'RFDEL-76M',
        applianceType: 'lighting',
        name: GetNameWithTranslation('', 'universal_6x150w_dimmer', undefined, 'box'),
        refImg: 'RFDEL-76M.png',
        icon: 'phase_actuator_din_6',
        dinrail: true,
        numberOfChannels: 6,
        usage: 'dimming',
        modules: 6,
        price: 376.75
    },
    {
        tech: 'wireless',
        type: 'RFDA-73M/RGB',
        applianceType: 'lighting',
        name: GetNameWithTranslation('', 'rgb_dimmer', ', 4x', 'box'),
        refImg: 'RFDA-73M_RGB.png',
        icon: 'phase_actuator_din_3',
        dinrail: true,
        numberOfChannels: 4,
        usage: 'dimming',
        modules: 3,
        price: 111.49
    },

    // Curtains 
    {
        tech: 'wireless',
        type: 'RFJA-32B-SL',
        applianceType: 'curtains',
        name: GetNameWithTranslation('', 'curtain_actuator', undefined, 'box'),
        refImg: 'RFJA-32B-SL.png',
        icon: 'actuator_curtain_box',
        dinrail: false,
        numberOfChannels: 1,
        usage: 'curtains',
        numberOfRequiredConnections: 2,
        price: 62.52
    },
    {
        tech: 'wireless',
        type: 'RFJA-52H/ISC',
        applianceType: 'curtains',
        name: GetNameWithTranslation('', 'curtain_actuator_slim'),
        refImg: 'RFJA-52H_ISC.png',
        icon: 'actuator_stas_stak_box',
        dinrail: false,
        numberOfChannels: 1,
        usage: 'curtains',
        numberOfRequiredConnections: 2,
        //price: 0
    },

    // HVAC
    {
        tech: 'wireless',
        type: 'RFATV-2',
        applianceType: 'hvac',
        usage: 'hvac',
        name: GetNameWithTranslation('', 'rfatv-2', undefined, 'box'),
        refImg: 'RFATV-2.png',
        icon: 'rfatv',
        numberOfChannels: 1,
        maximumAppliancesPerChannel: 1,
        dinrail: false,
        price: 85.92
    },
    {
        tech: 'wireless',
        type: 'TELVA-3',
        applianceType: 'hvac',
        usage: 'hvac',
        name: GetNameWithTranslation('', 'telva-3', undefined, 'box'),
        refImg: 'TELVA-3.png',
        icon: 'rfatv',
        numberOfChannels: 1,
        maximumAppliancesPerChannel: 1,
        dinrail: false,
        price: 25.31
    },
    {
        tech: 'wireless',
        type: 'RFSTI-11B-ST',
        applianceType: 'lighting',
        usage: 'switching',
        name: GetNameWithTranslation('', 'rfsti-11b-st', undefined, 'box'),
        refImg: 'RFSTI-11B-ST.png',
        icon: 'switching_actuator_box',
        numberOfChannels: 1,
        maximumAppliancesPerChannel: 1,
        dinrail: false,
        price: 0
    }

];
export const switchingActuators: ActuatorStateI[] = actuators.filter((actuator) => actuator.usage === 'switching');
export const dimmingActuators: ActuatorStateI[] = actuators.filter((actuator) => actuator.usage?.includes('dimming'));
export const curtainActuators: ActuatorStateI[] = actuators.filter((actuator) => actuator.usage === 'curtains');
export const hvacActuators: ActuatorStateI[] = actuators.filter((actuator) => actuator.applianceType === 'hvac' || actuator.type === 'RFSTI-11B-ST');